import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import requestShipList from './request/requestShipList'
import getCsrfToken from '@/store/Csrf'

import requestShipCompleteRegister from './request/requestShipCompleteRegister'
import requestShipEdit from './request/requestShipEdit'
import requestShipRegister from './request/requestShipRegister'

import property from './property'

const Actions = {
  // SHP01 出庫履歴一覧取得
  getShipListFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const requestList = requestShipList
    let req = params
    // 出庫庫履歴画面の時のみ
    if ('pageType' in params && params.pageType === 'ShipHistory') {
      req = requestList.request.createRequest(params.searchParameter)
    }

    return await axios
      // .get(apiMock.SHIP_LIST)
      .get(api.SHIP_LIST, { params: req })
      .then((response) => {
        const path = mutationsTypes.SHIP_SET_SHIP_LIST
        commit(path, response.data.data)

        // ページャーをセット
        const pagePath = mutationsTypes.UI_SET_PAGE_COUNT
        const pageCount = commonUtil.getPageCount(
          response.data.meta.totalRows,
          response.data.meta.perPage
        )
        commit(
          `UI/${pagePath}`,
          { length: pageCount, key: 'salesShip' },
          { root: true }
        )

        const getData = getters.getShipListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SHP03 出庫到着
  registerShipComplete: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestShipCompleteRegister.request.createRequest(params)
    const ret = await axios
      // .get(apiMock.SHIP_COMPLETE)
      .patch(`${api.SHIP_COMPLETE}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SHP03 出庫到着キャンセル
  registerShipCompleteCancel: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    await getCsrfToken()
    const req = requestShipCompleteRegister.request.createRequest(params)
    const ret = await axios
      // .get(apiMock.SHIP_COMPLETE_CANCEL)
      .patch(`${api.SHIP_COMPLETE_CANCEL}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    return ret
  },
  // SHP05 出庫微調整
  editShip: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestShipEdit.request.createRequest(params)

    return await axios
      // 疎通確認時、パス要確認
      .patch(`${api.SHIP_FIX}/${params.id}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SHP02 出庫キャンセル
  cancelShip: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.SHIP_CANCEL)
      .patch(`${api.SHIP_CANCEL}/${params.id}`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // SH07 出庫操作
  registerShip: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const req = requestShipRegister.request.createRequest(params)

    return await axios
      // .get(apiMock.SHIP_DETAIl_EDIT)
      .post(`${api.SHIP_DETAIl_EDIT}/${params.saleId}`, req)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)

        return false
      })
  },
  // USC01 一括出庫CSVインポート
  fileUpload: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    file
  ) => {
    const instance = axios.create({
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await getCsrfToken()
    return await instance
      // .get(apiMock.FILE_UPLOAD)
      .post(api.SHIP_CSV_UPLOAD, file)
      .then((response) => {
        console.log(response)
        const ret = commonUtil.afterApiSuccessProcess(
          response,
          response.data.results
        )
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  getShipListByIdFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    // const requestList = requestShipList
    // let req = params
    // // 出庫庫履歴画面の時のみ
    // if ('pageType' in params && params.pageType === 'ShipHistory') {
    //   req = requestList.request.createRequest(params.searchParameter)
    // }
    return {
      data: [
        {
          id: 1,
          date: '20/12/2022',
          sender: 'user',
          incomplete: '1',
          remark: '1'
        },
        {
          id: 2,
          date: '12/12/2022',
          sender: 'user',
          incomplete: '1',
          remark: '1'
        }
      ]
    }
  },
  getShipHistoryListByIdFromApi: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .get(`${api.SALE_SHIPMENT_DELIVERY_LIST}/${params.id}`)
      .then((response) => {
        const path = mutationsTypes.SHIP_GET_SHIP_DELIVERY_LIST
        const shipDeliveryList = response.data.data.scheduleShipList
        commit(path, shipDeliveryList)

        return {
          data: shipDeliveryList
        }
      })
      .catch((error) => {
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
    /*const requestList = requestShipList
    let req = params
    // 出庫庫履歴画面の時のみ
    if ('pageType' in params && params.pageType === 'ShipHistory') {
      req = requestList.request.createRequest(params.searchParameter)
    }
    const path = mutationsTypes.SHIP_GET_SHIP_DELIVERY_LIST
    const shipDeliveryList = [
      {
        date: '12/12/2022',
        user: {
          id: 34,
          organizationId: 37,
          lastName: 'Viet',
          firstName: 'Luong',
          phoneNumberCountryCode: null,
          phoneNumber: null,
          email: 'luongviet82@gmail.com',
          emailVerifiedAt: '2023-03-30 12:10:10',
          iconImgUrl: null,
          section: null,
          position: null,
          authorityId: 1,
          invitedAt: null,
          lastLoginAt: '2023-04-13 15:33:17',
          tutorialStatus: 1,
          createdAt: '2023-03-30 12:10:01',
          updatedAt: '2023-04-13 15:33:17',
          organization: null
        },
        products: [
          {
            product_id: 17,
            rackProductList: [
              {
                quantity: 1,
                estimated_shipping_date: '2023-04-15',
                delivery_date: '2023-04-17'
              }
            ],
            user_id: 34,
            organization_id: 37,
            created_at: '2023-04-12',
            updated_at: '2023-04-12T04:21:37.000000Z'
          },
          {
            product_id: 18,
            rackProductList: [
              {
                quantity: 1,
                estimated_shipping_date: '2023-04-15',
                delivery_date: '2023-04-17'
              },
              {
                quantity: 1,
                estimated_shipping_date: '2023-04-19',
                delivery_date: '2023-04-20'
              }
            ],
            user_id: 34,
            organization_id: 37,
            created_at: '2023-04-12',
            updated_at: '2023-04-12T04:21:37.000000Z'
          }
        ]
      },
      {
        date: '13/12/2022',
        user: {
          id: 34,
          organizationId: 37,
          lastName: 'Viet',
          firstName: 'Luong',
          phoneNumberCountryCode: null,
          phoneNumber: null,
          email: 'luongviet82@gmail.com',
          emailVerifiedAt: '2023-03-30 12:10:10',
          iconImgUrl: null,
          section: null,
          position: null,
          authorityId: 1,
          invitedAt: null,
          lastLoginAt: '2023-04-13 15:33:17',
          tutorialStatus: 1,
          createdAt: '2023-03-30 12:10:01',
          updatedAt: '2023-04-13 15:33:17',
          organization: null
        },
        products: [
          {
            product_id: 17,
            rackProductList: [
              {
                quantity: 1,
                estimated_shipping_date: '2023-04-15',
                delivery_date: '2023-04-17'
              }
            ],
            user_id: 34,
            organization_id: 37,
            created_at: '2023-04-12',
            updated_at: '2023-04-12T04:21:37.000000Z'
          },
          {
            product_id: 18,
            rackProductList: [
              {
                quantity: 1,
                estimated_shipping_date: '2023-04-15',
                delivery_date: '2023-04-17'
              },
              {
                quantity: 1,
                estimated_shipping_date: '2023-04-19',
                delivery_date: '2023-04-20'
              }
            ],
            user_id: 34,
            organization_id: 37,
            created_at: '2023-04-12',
            updated_at: '2023-04-12T04:21:37.000000Z'
          }
        ]
      }
    ]
    commit(path, {
      shipDeliveryList
    })
    return {
      data: shipDeliveryList
    }*/
  }
}

export default Actions
